import type { LocalizedFieldDto } from '@carvia/ros-client-types';
import * as yup from 'yup';

export const localizedField = yup.object({
  de: yup.string().required(),
  en: yup.string().required(),
});

export const optionalLocalizedField = yup
  .object({
    de: yup.string().nullable(),
    en: yup.string().nullable(),
  })
  .nullable()
  .optional();

type OptionalLocalizedField = yup.InferType<typeof optionalLocalizedField>;

/** The API expects both languages on a stored value, so blank input is cleared and a partial one is filled up. */
export const toOptionalLocalizedField = (
  field: OptionalLocalizedField,
): LocalizedFieldDto | null => {
  if (!field?.de?.trim() && !field?.en?.trim()) return null;
  return { ...field, de: field.de ?? '', en: field.en ?? '' };
};
